module.exports = __webpack_public_path__ + "static/media/xiazai.eacb61c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xiazai.mp4
// module id = T89y
// module chunks = 0